import React from "react";
import { Stack, Typography } from "@mui/material";
import { IOSSwitch } from "./iosSwitch";
import { useMCContext } from "../contexts/useMCStates";
import type { PriceDisplayMode } from "../../utils/eventPricingUtils";

export const PriceDisplayModeToggle = () => {
    const { priceDisplayMode, setPriceDisplayMode, factor } = useMCContext();

    const handleChange = (checked: boolean) => {
        const mode: PriceDisplayMode = checked ? "total" : "perPlayer";
        setPriceDisplayMode(mode);
    };

    return (
        <Stack
            direction="row"
            spacing={1 * factor}
            alignItems="center"
            justifyContent="center"
            flexWrap="wrap"
            sx={{ maxWidth: "100%" }}
        >
            <Typography
                variant="body2"
                sx={{
                    fontWeight: priceDisplayMode === "perPlayer" ? 600 : 400,
                    color: priceDisplayMode === "perPlayer" ? "text.primary" : "text.secondary",
                    fontSize: `${0.8 * factor}rem`,
                }}
            >
                Per player
            </Typography>
            <IOSSwitch
                checked={priceDisplayMode === "total"}
                onChange={(e) => handleChange(e.target.checked)}
                inputProps={{ "aria-label": "Toggle between per player and total cost price display" }}
            />
            <Typography
                variant="body2"
                sx={{
                    fontWeight: priceDisplayMode === "total" ? 600 : 400,
                    color: priceDisplayMode === "total" ? "text.primary" : "text.secondary",
                    fontSize: `${0.8 * factor}rem`,
                }}
            >
                Total cost
            </Typography>
        </Stack>
    );
};
